import React, {FunctionComponent, useEffect} from 'react';

import {IShippingAndTax} from "../../../models/ShippingAndTax/ShippingAndTax";
import {arraySum, displayDate, displayDollarAmount} from "../../../lib/utilities";
import {observer} from "mobx-react-lite";
import {useAPIPager} from "../../../hooks/useAPIPager";
import Agent from "../../../api/Agent";
import {useSelectTable} from "../../../hooks/useSelectTable";
import Table from '../../table/Table';
import THead from '../../table/THead';
import TR from '../../table/TR';
import TD from "../../table/TD";
import TBody from '../../table/TBody';
import Pagination from "../../table/Pagination";
import Skeleton from "../../generic/Skeleton";
import Checkbox from "../../Inputs/Checkbox";

interface OwnProps {
    onChange?: (e: string[]) => (void)
    selected?: string[]
    predicates?: Map<any, any>
}

type Props = OwnProps;

const ShippingAndTaxSelectTable: FunctionComponent<Props> = ({onChange, selected, predicates}) => {
    // Pager
    const {items, count, handleChangePage, isLoading} = useAPIPager(Agent.ShippingAndTaxes, predicates)
    const {handleCheckAll, handleCheck, selectedItems} = useSelectTable(selected);

    // Use Effects
    useEffect(() => {
        !!onChange && onChange(selectedItems)
    }, [selectedItems]);

    return (<>
        <span className="sr-only" id="shippingAndTaxSelectTable">Shipping and Tax</span>
        <Table className={'max-w-full'} aria-describedby={'shippingAndTaxSelectTable'}>
            <THead>
                <TR>
                    <TD className={'th min-w-max whitespace-nowrap'}>
                        {items.length > 0 && <>
                            <span id="selectAllShippingAndTaxes" className="sr-only">Select all</span>
                            <Checkbox label={<span className={'sr-only'}>Select</span>}
                                checked={items.every(i => selectedItems?.includes(i.id))}
                                className="border-gray-300 rounded"
                                onChange={(e) => handleCheckAll(e, items)}/></>}
                    </TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Description</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Receipt Number</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Invoice Date</TD>
                    <TD className={'th min-w-max whitespace-nowrap'}>Cost</TD>
                </TR>
            </THead>
            <TBody>
                {items?.map((shippingAndTax: IShippingAndTax, idx) => {
                    return (<TR key={idx}>
                        {isLoading ? <TD colSpan={100}><Skeleton/></TD> : <>
                            <TD className={'td min-w-max whitespace-nowrap'}>
                                <Checkbox checked={selectedItems.includes(shippingAndTax.id ?? '')}
                                       onChange={handleCheck} value={shippingAndTax.id}
                                       label={<span className={'sr-only'}>Select</span>}
                                />
                            </TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{shippingAndTax?.description}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{shippingAndTax?.receiptNumber}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{displayDate(shippingAndTax?.invoiceDate)}</TD>
                            <TD className={'td min-w-max whitespace-nowrap'}>{displayDollarAmount(arraySum([
                                shippingAndTax.shippingOrTaxCosts,
                                shippingAndTax.shippingCosts,
                                shippingAndTax.taxCosts,
                            ]))}</TD>
                        </>}
                    </TR>)
                })}
            </TBody>
        </Table>
        <Pagination totalRows={count} onPageChange={handleChangePage} onRowChange={handleChangePage}/>
    </>);
};

export default observer(ShippingAndTaxSelectTable);
